











































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import GenericInput from './Input.vue';
import GenericButton from './Button.vue';
import Typer from '../Typer.vue';
import Spinner from '../Spinner.vue';
import { debounce } from 'lodash';

@Component({
  components: {
    GenericInput,
    GenericButton,
    Typer,
    Spinner,
  },
})
export default class Autocomplete extends Vue {
  public syncedSearch = '';
  public typing = false;
  public selectedResultIndex = -1;

  @Prop({ type: String, default: '' }) readonly search!: string;
  @Prop({ type: String, default: 'text' }) private type!: string;
  @Prop({ type: Boolean, default: false }) private loading!: boolean;
  @Prop({ default: null }) private results!: Array<unknown> | null;
  @Prop({ default: false }) private focus!: boolean;

  focusInput() {
    ((this.$refs.inputComponent as Vue).$refs
      .inputEl as HTMLInputElement).focus();
  }

  mounted() {
    this.$nextTick(() => {
      this.syncedSearch = this.search;
      if (this.focus) {
        this.focusInput();
      }
    });
  }

  @Watch('results')
  onResultsChanged() {
    this.$nextTick(() => {
      this.focusInput();
    });
  }

  @Watch('search')
  onValueChanged() {
    this.syncedSearch = this.search;
  }

  created() {
    this.onSearchChanged = debounce(this.onSearchChanged, 750);
  }

  onInput(newValue: string) {
    this.typing = true;
    this.onSearchChanged(newValue);
  }

  @Emit('search')
  onSearchChanged(newValue: string) {
    this.typing = false;
    return newValue; // actually emits
  }

  @Emit('select-result')
  selectResult(result: unknown) {
    return result;
  }

  get targetLi(): HTMLElement {
    return this.$refs[`result-${this.selectedResultIndex}`] as Array<
      HTMLElement
    >[0];
  }

  onArrowDown() {
    if (this.results && this.selectedResultIndex < this.results.length - 1) {
      this.selectedResultIndex = this.selectedResultIndex + 1;
      this.targetLi.scrollIntoView(false);
    }
  }
  onArrowUp() {
    if (this.selectedResultIndex > 0) {
      this.selectedResultIndex = this.selectedResultIndex - 1;
      this.targetLi.scrollIntoView(true);
    }
  }
  onEnter() {
    if (this.results) {
      this.selectResult(this.results[this.selectedResultIndex]);
    }
  }
}
